import React, { useEffect, useState } from 'react';
import pic from "../assets/jdb.png";
import '../styles/ChairmanDesk.css';

export default function ChairmanDesk() {
     const [isVisible, setIsVisible] = useState(false);
    
      useEffect(() => {
        setIsVisible(true);
      }, []);
      
      return (
    <div className="president-wrapper">
      {/* Hero Banner with Image */}
      <section className={`sgb-hero-banner ${isVisible ? 'sgb-fade-in' : ''}`}>
        <div className="sgb-hero-overlay">
          <div className="sgb-hero-text-content">
            <h1 className="sgb-hero-main-title">Chairman's Desk</h1>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="president-content">
        
        {/* Left Side - Message */}
        <div className="president-right">
          <h3 className="dear-students">Dear Students</h3>
          
          <p className="message-para">
            You Are Heartily Welcomed In The New Session. Seth. Girdhari Lal Bihani S.D. Sr. Sec School Was Established In 1951. This School Is The First Virtuous Work Of Danveer Seth. Girdhari Lal Bihani And A Beacon Of Light In The Field Of Education Which Is Dedicated To Mother Saraswathi In The Field Of Modern But Cultured And Disciplined Education This Galaxy Of Knowledge Flows Continuously In Various Forms Of Education. You Will Have All Round Development In This School. This School Provides Opportunities For Students Along With Academic And Co-Scholastic Activities. The Enlightened Faculty Is Committed For Shaping The Future Of The Students Through Transparent And Practical Teaching By Making The Most Difficult Subjects Easy And Simple.
          </p>

          <p className="message-para">
            I Believe That School Should Not Be Considered A Place Where Certain Knowledge Can Be Merely Learned But It Should Be A Place Where Students Are Trained In Particular Forms Of Activities Which Have The Most Importance In Life.
          </p>

          <p className="message-para">
            Our Aim Is To Create A Balanced Mind Which Is Helpful In Building The Personality Of The Students. According To The Proud Tradition Of The School Along With The Modern Education, Information About History, Religion, Philosophy And Literature Is Also Given To The Students From Time To Time So That They Become Familiar With Their Culture And Can Create New Values For The Future As Per The Circumstances.
          </p>
        </div>

        {/* Right Side - Photo and Details */}
        <div className="president-left">
          <div className="president-photo-box">
            <img src={pic} alt="Chairman" className="president-img" />
          </div>
          
          <div className="president-info">
            <h2 className="president-name">SHRI JAIDEEP JI BIHANI</h2>
            <p className="president-role">CHAIRMAN</p>
            <p className="president-org">SETH. G.L BIHANI S.D. SR. SEC. SCHOOL</p>
          </div>
        </div>

      </div>
    </div>
  );
}